import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, Check, Loader2 } from "lucide-react";

export default function WaitlistForm({ onSubmit, joined, testIdPrefix = "hero" }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [localJoined, setLocalJoined] = useState(false);

  const showSuccess = joined || localJoined;

  const handle = async (e) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);
    const ok = await onSubmit(email);
    setSubmitting(false);
    if (ok) setLocalJoined(true);
  };

  return (
    <div data-testid={`${testIdPrefix}-waitlist`} className="w-full">
      <AnimatePresence mode="wait">
        {!showSuccess ? (
          <motion.form
            key="form"
            onSubmit={handle}
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.35 }}
            className="flex items-stretch w-full border-b border-zinc-900/80 focus-within:border-[#EA580C] transition-colors"
          >
            <input
              data-testid={`${testIdPrefix}-email-input`}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@domain.com"
              className="flex-1 bg-transparent outline-none py-3 text-base text-zinc-900 placeholder:text-zinc-400 font-sans"
            />
            <button
              data-testid={`${testIdPrefix}-submit-button`}
              type="submit"
              disabled={submitting}
              className="ml-4 inline-flex items-center gap-2 px-5 py-3 bg-zinc-950 text-white text-sm tracking-wide hover:bg-[#EA580C] transition-colors disabled:opacity-60 font-sans"
            >
              {submitting ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  Joining
                </>
              ) : (
                <>
                  Join waitlist
                  <ArrowRight className="w-4 h-4" />
                </>
              )}
            </button>
          </motion.form>
        ) : (
          <motion.div
            key="success"
            data-testid={`${testIdPrefix}-success-message`}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-3 py-4 border-b border-[#EA580C]"
          >
            <span className="w-7 h-7 rounded-full bg-[#EA580C] text-white flex items-center justify-center">
              <Check className="w-4 h-4" />
            </span>
            <div>
              <div className="font-serif text-xl text-zinc-900">You're on the list.</div>
              <div className="text-xs tracking-widest uppercase text-zinc-500 mt-1 font-sans">
                We'll be in touch before issue 001.
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
